/**
 * Debounce Promise
 * @param callback
 * @param wait
 * @returns {function(...[*]): Promise<unknown>}
 */
export function debouncePromise(callback, wait) {
    let timeout;
    let resolvePromise;

    return function (...args) {
        clearTimeout(timeout);

        return new Promise((resolve) => {
            resolvePromise = resolve;

            timeout = setTimeout(async () => {
                const result = await callback.apply(this, args);
                resolvePromise(result);
            }, wait);
        });
    };
}
